import { User } from '@teachur/http-client';
import { Role, SubscriptionStatus } from '@types';
import moment from 'moment';

export const isUserInstructor = (user: User) => {
  return user.role === Role.Instructor || user.role === Role.Admin || user.role === Role.SuperAdmin;
};

export const isUserAdmin = (user: User) => {
  return user.role === Role.Admin || user.role === Role.SuperAdmin;
};

export const isUserNew = (user: User) => {
  return moment.duration(moment().diff(moment(user.createdAt))).asDays() < 4;
};
export const isUserStudent = (user: User) => {
  return user.role === Role.Student;
};

export const isUserSuperAdmin = (user: User) => {
  return user.role === Role.SuperAdmin;
};

export const isUserSubscriptionCanceled = (user: User) => user.subscriptionStatus === 'canceled';

export const isUserSubscribed = (user: User) => {
  const subscribedStatuses: SubscriptionStatus[] = ['active', 'trialing', 'past_due'];

  if (user.role !== Role.Student) {
    return true;
  }

  if (!user.subscriptionStatus) {
    return false;
  }

  return subscribedStatuses.indexOf(user.subscriptionStatus) !== -1;
};

export const scrollToRef = (ref: any) => {
  window.scrollTo(0, ref.current.offsetTop);
};

export const getFileUrl = (fileUrl: string) => {
  if (!fileUrl) {
    return (fileUrl = '');
  }
  if (fileUrl.startsWith('http')) {
    return fileUrl;
  }

  return `https://${fileUrl}`;
};

export const formatSecondsToHumanReadable = (seconds: number) => {
  // Hours, minutes and seconds
  const hrs = ~~(seconds / 3600);
  const mins = ~~((seconds % 3600) / 60);
  const secs = ~~seconds % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = '';
  if (hrs > 0) {
    ret += '' + hrs + ':';
  }
  ret += '' + String(mins).padStart(2, '0') + ':' + (secs < 10 ? '0' : '');
  ret += '' + secs;
  return ret;
};
